import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { IsWidgetAccessible } from '../../utils/widgetManager';
import { FormattedMessage } from 'react-intl';
import { Navigate, useParams } from 'react-router-dom';
import { initialModelCategoryState } from '../../reducers/initialState';
import Cookies from 'js-cookie';

const envName = process.env.REACT_APP_ENV_NAME_SHORT;

const ModelCategoryConfiguration = ({ userProfileWidgets,
  describeModelCategory,
  modelCategoryCleanUp
}) => {

  let widgetCode = 'MODELCATEGORY_CONFIGURE';
  const organisationId = Cookies.get(`selectedorganisationid-${envName}`) || 0;
  // Check if the user has access to any of the widgets
  let { ModelCategoryId } = useParams();

  useEffect(() => {
    if (ModelCategoryId && organisationId && widgetCode) {
      describeModelCategory(ModelCategoryId, organisationId, widgetCode);
    }
  }, [describeModelCategory, ModelCategoryId, organisationId, widgetCode]);

  useEffect(() => {
    return () => {
      modelCategoryCleanUp({
        ...initialModelCategoryState.modelCategoryManager
      });
    };
  }, []);


  return (
    <div>
      {IsWidgetAccessible(userProfileWidgets, 'MODELS_TAB') ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-list`} />
      ) : IsWidgetAccessible(userProfileWidgets, 'MODELCOMPONENTTYPE_LIST') ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-component-type-list`} />
      ) : IsWidgetAccessible(userProfileWidgets, 'APPROVEDCOMPONENT_LIST') ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/approved-component-list`} />
      ) : IsWidgetAccessible(userProfileWidgets, 'MODELCOMPONENTPOSITION_LIST') ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-component-position-list`} />
      ) : IsWidgetAccessible(userProfileWidgets, 'SIGNALTRANSLATIONS_TAB') ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/signal-translation-equation-list`} />
      ) : IsWidgetAccessible(userProfileWidgets, 'SETPOINTS_TAB') ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/setpoints`} />
      ) : IsWidgetAccessible(userProfileWidgets, 'EVENTCODES_TAB') ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/event-code-list`} />
      ) : (
        ''
      )}
      <span>
        <FormattedMessage
          id="modelCategory.noAccess"
          defaultMessage="You do not have access to model category operations. Please contact your administrator."
        />
      </span>
    </div>
  )
};

ModelCategoryConfiguration.propTypes = {
  userProfileWidgets: PropTypes.object.isRequired
};

export default ModelCategoryConfiguration;
